
var _ = require('lodash');
var URLHelper = require('utils/URLHelper.js');
var SignUpService = require('signup/SignUpService.js');

function AnalyticsService() {
    if(!URLHelper.isLocal()){
        SignUpService.onLoginEnd(setupAnalytics);
    }
}

module.exports = new AnalyticsService();

function setupAnalytics(user) {
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

    var id = _.get(user, '_id');
    var email = _.get(user, 'username');
    var userId = id ? { userId : id } : 'auto';

    ga('create', 'UA-98294555-1', userId);

    if(id){
        ga('require', 'displayfeatures');
        ga('set', 'dimension1', id);
    }
    ga('send', 'pageview');

    window.addEventListener("hashchange", updateGA, false);

    function updateGA() {
        var url = location.pathname + location.search + location.hash;
        ga('set', 'page', url);
    
        if(id && email){
            ga('set', 'dimension1', email);
        }
        ga('send', 'pageview');
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/js/services/AnalyticsService.js
// module id = 9
// module chunks = 0 1